import { c as _c } from "react/compiler-runtime";
import { SparkCTA } from '@/components/spark/SparkCTA';
import { SparkHero } from '@/components/spark/SparkHero';
import { SparkInspiration } from '@/components/spark/SparkInspiration';
import { SparkStarters } from '@/components/spark/SparkStarters';
import Head from 'next/head';
export default function SparkPage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Head><title>{"Spark \u2014 Proven Initiatives & Playbooks | Sizzle"}</title><meta name="description" content="Inspiration, playbooks, and ready-to-use fast start initiative library for food and beverage brands. Case studies, proven activations, and step-by-step guides." /></Head>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<main className="overflow-hidden bg-[#fffaf4] text-gray-950"><SparkHero /><SparkInspiration /><SparkStarters /><SparkCTA /></main></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}